import * as React from 'react';

import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import QRCode from 'components/qrcode';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

interface IWhopperQrCodeWidgetProps {
  shortCode?: string;
}

const WhopperQrCodeWidget: React.FC<IWhopperQrCodeWidgetProps> = ({ shortCode }) => {
  const title = t('whopperQrTitle', 'Or scan this QR code');
  const subtitle = t('whopperQrSubtitle', 'Cashier can scan this code');
  const barcodeOptions = {
    margin: 1,
    width: 180,
    color: {
      dark: primitive.$black,
      light: primitive.$white,
    },
  };

  if (!shortCode) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Typography style={styles.title} accessibilityLabel={title}>
        {title}
      </Typography>
      <Typography style={styles.subtitle} accessibilityLabel={subtitle}>
        {subtitle}
      </Typography>
      <View style={styles.qrContainer}>
        <QRCode testID="whopper-qr-code" barcode={shortCode || ''} options={barcodeOptions} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F5A623',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    alignItems: 'center',
    paddingTop: 20,
    paddingBottom: 60,
    paddingHorizontal: 24,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
    color: primitive.$bbqBrown,
    fontFamily: 'Flame',
  },
  subtitle: {
    fontSize: 14,
    fontWeight: '400',
    marginBottom: 24,
    textAlign: 'center',
    color: primitive.$bbqBrown,
    fontFamily: 'Flame Sans',
  },
  qrContainer: {
    padding: 24,
    backgroundColor: '#fff',
    borderRadius: 16,
  },
});

export default WhopperQrCodeWidget;
